export default {
  '_b._qhyy': 'Switch Language',

  '_a._jzz': 'Loading...',
  '_a._jzgd': 'Load More',
  '_a._wct': 'Welcome to',
  '_a._gd': 'More',
  '_a._bf': 'Play',
  '_a._bcz': 'Saving...',
  '_a._sctp': 'Upload Image',

  '_dl._qssyx': 'Please enter email',
  '_dl._qssmm': 'Please enter password',
  '_dl._ann': 'Login',
  '_dl._hmyzh': "Don't have an account?",
  '_dl._qzc': 'Register',
  '_dl._yzhl': 'Already have an account?',
  '_dl._qdl': 'Login',
  '_dl._srqrmm': 'Please confirm password',
  '_dl._sryqm': 'Please enter invitation code',
  '_dl._sryzm': 'Please enter verification code',
  '_dl._ljzc': 'Register Now',
  '_dl._zcbsty': 'Registration means you have read and agree to the',
  '_dl._yszc': 'Privacy Policy',
  '_dl._lcmmbyy': 'Passwords do not match',

  '_yzm._fsyzm': 'Send Verification Code',
  '_yzm._cxfs': '({time}) Resend',
  '_yzm._fsz': 'Sending...',
  '_yzm._fscg': 'Sent Successfully',

  '_h._zrm': 'Most Popular',
  '_h._zxd': 'Newest',
  '_h._phb': 'Ranking',
  '_h._qz': 'Wallpaper',
  '_h._ssww': 'Search',
  '_h._lsjl': 'History',
  '_h._gd': 'More',
  '_h._dl': 'Login',
  '_h._ye': 'Balance',
  '_h._dj': 'Frozen',
  '_h._ybp': 'Dashboard',
  '_h._wdqb': 'My Wallet',
  '_h._scjl': 'Favorites',
  '_h._xxzx': 'Message Center',
  '_h._fxhy': 'Share with Friends',
  '_h._bzzx': 'Help Center',
  '_h._ggtf': 'Ad Placement',
  '_h._bqtz': 'Copyright Investment',
  '_h._sz': 'Settings',

  '_sy._jx': 'Featured',
  '_sy._xpfb': 'New Releases',
  '_sy._gdsp': 'More Videos',

  '_qz._jbqz': 'Exquisite Wallpaper Collection',
  '_qz._ssqz': 'Search Wallpaper',
  '_qz._qb': 'All',
  '_qz._zrfg': 'Natural Scenery',
  '_qz._cxys': 'Abstract Art',
  '_qz._csjz': 'Urban Architecture',
  '_qz._dmyx': 'Anime & Games',
  '_qz._yzxk': 'Cosmos & Stars',
  '_qz._yl': 'Preview',
  '_qz._xzqz': 'Download Wallpaper',
  '_qz._fbl': 'Resolution',
  '_qz._fl': 'Category',
  '_qz._jzz': 'Loading',
  '_qz._myzdpp': 'No matching wallpapers found',

  '_sp._xyjscl': 'Unlock required to watch',
  '_sp._cz': 'Top Up',
  '_sp._jsqj': 'Unlock All Episodes',
  '_sp._jsbj': 'Unlock This Episode',
  '_sp._sc': 'Favorite',
  '_sp._fx': 'Share',
  '_sp._jsqjjs': 'Confirm payment of {a} to unlock all episodes?',
  '_sp._jsbjjs': 'Confirm payment of {a} to unlock this episode?',
  '_sp._zfz': 'Processing Payment...',
  '_sp._qrzf': 'Confirm Payment',
  '_sp._qx': 'Cancel',

  '_qz._smrc': 'Mountain Sunrise',
  '_qz._cxjh': 'Abstract Geometry',
  '_qz._dsyj': 'City Nightscape',
  '_qz._dmfj': 'Anime Landscape',
  '_qz._hhxk': 'Vast Starry Sky',
  '_qz._slmw': 'Forest Mist',
  '_qz._scld': 'Color Flow',
  '_qz._xdjz': 'Modern Architecture',

  '_qb._cbjl': 'Deposit History',
  '_qb._jyjl': 'Transaction History',
  '_qb._bddz': 'Bound Addresses',
  '_qb._txjl': 'Withdrawal History',

  '_m._tcdl': 'Log Out',
  '_m._cb': 'Deposit',
  '_m._tb': 'Withdraw',

  '_cb._ssdz': 'Search currency or address',
  '_cb._bz': 'Currency',
  '_cb._je': 'Amount',
  '_cb._dz': 'Address',
  '_cb._sj': 'Time',
  '_cb._cz': 'Action',
  '_cb._zwjl': 'No transaction records yet',
  '_cb._dny': 'Page {a} of {b}',
  '_cb._jyxq': 'Transaction Details',
  '_cb._jydz': 'Transaction Address',
  '_cb._zt': 'Status',
  '_cb._yqr': 'Confirmed',
  '_cb._qb': 'All',
  '_cb._jt': 'Today',
  '_cb._j7t': 'Last 7 Days',
  '_cb._j30t': 'Last 30 Days',
  '_cb._zw': 'None',
  '_cb._fzcg': 'Address copied to clipboard',

  '_jyjl._ssdz': 'Search currency or address',
  '_jyjl._lx': 'Type',
  '_jyjl._je': 'Amount',
  '_jyjl._ye': 'Balance',
  '_jyjl._dj': 'Frozen',
  '_jyjl._sj': 'Time',
  '_jyjl._cz': 'Action',
  '_jyjl._zwjyjl': 'No transaction records yet',
  '_jyjl._czsx': 'Reset Filter',
  '_jyjl._dny': 'Page {a} of {b}',
  '_jyjl._jyxq': 'Transaction Details',
  '_jyjl._jylx': 'Transaction Type',
  '_jyjl._jyje': 'Transaction Amount',
  '_jyjl._jyhye': 'Balance After Transaction',
  '_jyjl._djye': 'Frozen Amount',
  '_jyjl._jysj': 'Transaction Time',
  '_jyjl._jyzt': 'Transaction Status',
  '_jyjl._ywc': 'Completed',
  '_jyjl._qb': 'All',
  '_jyjl._jt': 'Today',
  '_jyjl._j7t': 'Last 7 Days',
  '_jyjl._j30t': 'Last 30 Days',

  '_jyjl._tp1': 'Deposit',
  '_jyjl._tp2': 'Withdrawal',
  '_jyjl._tp3': 'Payment',
  '_jyjl._tp4': 'Deposit',
  '_jyjl._tp5': 'Freeze',
  '_jyjl._tp6': 'Earnings',
  '_jyjl._tp7': 'Referral Reward',
  '_jyjl._tp8': 'Login Reward',
  '_jyjl._tp9': 'Promotion Earnings',
  '_jyjl._tp10': 'Video Reward',
  '_jyjl._tp11': 'Registration Bonus',
  '_jyjl._tp12': 'Withdrawal rejected',
  '_jyjl._tp13': 'Message Red Packet',

  '_jyjl._tp14': 'Internal Transfer',

  '_cb._shz': 'Under Review',
  '_cb._yyg': 'Approved',
  '_cb._ybh': 'Rejected',

  '_bddz._tjdz': 'Add Address',
  '_bddz._ssdz': 'Search Address',
  '_bddz._bz': 'Currency',
  '_bddz._dz': 'Address',
  '_bddz._sysj': 'Last Used',
  '_bddz._cz': 'Action',
  '_bddz._zwjl': 'No address records yet',
  '_bddz._dny': 'Page {a} of {b}',
  '_bddz._dzewm': 'Address QR Code',
  '_bddz._fzdz': 'Copy Address',
  '_bddz._dzxq': 'Address Details',
  '_bddz._wl': 'Network',
  '_bddz._tjsj': 'Added Time',
  '_bddz._bzwa': 'Note',
  '_bddz._ntq': '{a} days ago',
  '_bddz._nxsq': '{a} hours ago',
  '_bddz._nfzq': '{a} minutes ago',
  '_bddz._ngg': 'Just now',
  '_bddz._dzyfz': 'Address copied to clipboard',
  '_bddz._scqr': 'Delete Confirmation',
  '_bddz._scqrdz': 'Are you sure you want to delete this address?',
  '_bddz._qr': 'Confirm',
  '_bddz._qx': 'Cancel',
  '_bddz._scdzcg': 'Address deleted successfully',

  '_txjl._ztsx': 'Status Filter',
  '_txjl._qbzt': 'All Status',
  '_txjl._shz': 'Under Review',
  '_txjl._ytg': 'Approved',
  '_txjl._yjj': 'Rejected',
  '_txjl._ssdz': 'Search address or amount',
  '_txjl._bz': 'Currency',
  '_txjl._je': 'Amount',
  '_txjl._dz': 'Address',
  '_txjl._zt': 'Status',
  '_txjl._sj': 'Time',
  '_txjl._cz': 'Action',
  '_txjl._zwjl': 'No transaction records yet',
  '_txjl._czsx': 'Reset Filter',
  '_txjl._dny': 'Page {a} of {b}',
  '_txjl._jyxq': 'Transaction Details',
  '_txjl._skdz': 'Receiving Address',
  '_txjl._jysj': 'Transaction Time',
  '_txjl._jyzt': 'Transaction Status',
  '_txjl._fzdz': 'Address copied to clipboard',

  '_cbsq._bz': 'Currency',
  '_cbsq._wl': 'Network',
  '_cbsq._erwm': 'QR Code',
  '_cbsq._fzdz': 'Copy Address',

  '_txsq._bz': 'Currency',
  '_txsq._wl': 'Network',
  '_txsq._ye': 'Balance',
  '_txsq._sxf': 'Fee',
  '_txsq._zxtx': 'Min Withdrawal',
  '_txsq._txdz': 'Withdrawal Address',
  '_txsq._qxztxdz': 'Please select withdrawal address',
  '_txsq._txje': 'Withdrawal Amount',
  '_txsq._qsrtxje': 'Please enter withdrawal amount',
  '_txsq._yxyzm': 'Email Verification Code',
  '_txsq._qsryxyzm': 'Please enter verification code',
  '_txsq._ljtx': 'Withdraw Now',

  '_jl._wxhd': 'My Likes',
  '_jl._lsjl': 'History',

  '_xx._bt': 'Message Center',
  '_xx._wjl': 'No Records',
  '_xx._zsmyxx': 'No messages yet',
  '_xx._sxxx': 'Refresh Messages',
  '_xx._sxcg': 'Refreshed Successfully',

  '_fx._fxhy': 'Share with Friends',
  '_fx._smfx': 'Scan QR code to share with friends',
  '_fx._jlsm': 'Reward Description',
  '_fx._jlsm1': '1. Friends you directly invite (Level 1) will grant you {a}% of their earnings.',
  '_fx._jlsm2': '2. Friends invited by your Level 1 friends (Level 2) will grant you {a}% of their earnings.',
  '_fx._jlsm3': '3. Friends invited by your Level 2 friends (Level 3) will grant you {a}% of their earnings.',
  '_fx._fzlj': 'Copy Link',

  '_bzzx._bzzx': 'Help Center',
  '_bzzx._rhzczh': 'How to Register an Account',
  '_bzzx._zclc': 'Registration Process',
  '_bzzx._rhzcxyh': 'How to register a new account?',
  '_bzzx._rhzcxyh1': 'Click the "Register" button, enter your email address, set a password, and complete email verification to successfully register an account.',
  '_bzzx._rhcz': 'How to Top Up?',
  '_bzzx._rhcz1': 'Top-up Process',
  '_bzzx._rhcz2': 'Detailed top-up instructions',
  '_bzzx._rhcz3': 'Click My Wallet, Deposit, select the cryptocurrency you want to deposit, and send to the provided address.',

  '_bzzx._rhjsdj': 'How to Unlock Short Drama',
  '_bzzx._rhjsdj2': 'Click to unlock individual episodes and watch more exciting content.',

  '_bzzx._rhtx': 'How to Withdraw from Account',
  '_bzzx._rhtx1': '1. Go to My Wallet, Withdrawal Addresses, add a new withdrawal address for the corresponding cryptocurrency.<br>2. Click Withdraw, select the cryptocurrency, choose a bound address, enter the withdrawal amount, and wait for it to arrive.',

  '_bzzx._qtwt': 'Other Questions',
  '_bzzx._qtwt1': 'How to contact customer service?',
  '_bzzx._qtwt2': 'You can contact us via the online in the lower right corner of the website, customer service email, or hotline.',
  '_bzzx._myzdwt': "Didn't find the answer you were looking for?",
  '_bzzx._khjybbzn': 'Our customer service team is happy to provide further assistance.',
  '_bzzx._lxkf': 'Contact Customer Service',

  '_ggtf._bt1': 'Ad Placement',
  '_ggtf._splb': 'Video List',
  '_ggtf._wcyd': 'My Participation',
  '_ggtf._hdbm': 'Event Code',
  '_ggtf._tian': 'Days',
  '_ggtf._kssj': 'Start Time',
  '_ggtf._jssj': 'End Time',
  '_ggtf._ddvp': 'Reach VIP Level {a}, average {b} participations per person',
  '_ggtf._hdzt': 'Event Status',
  '_ggtf._wks': 'Not Started',
  '_ggtf._ycy': 'Participated',
  '_ggtf._qg': 'Buy Now',
  '_ggtf._mygdl': 'No more data',
  '_ggtf._qgrtd': 'Too many buyers, please try again',
  '_ggtf._hdxq': 'Event Details',
  '_ggtf._hdjs': 'Event Description',
  '_ggtf._cyyq': 'Participation Requirements',
  '_ggtf._zdtz': 'Minimum Investment',
  '_ggtf._vpdj': 'VIP Level',
  '_ggtf._rjcy': 'Average Participation',
  '_ggtf._gmje': 'Purchase Amount',
  '_ggtf._qsrgmje': 'Please enter purchase amount',
  '_ggtf._qx': 'Cancel',
  '_ggtf._ljcy': 'Participate Now',
  '_ggtf._ssjymm': 'Enter Transaction Password',
  '_ggtf._qssjymm': 'Please enter transaction password',
  '_ggtf._ji': 'Level',
  '_ggtf._ci': 'times',
  '_ggtf._zdgm': 'Minimum Purchase Amount',
  '_ggtf._zggm': 'Maximum Purchase Amount',
  '_ggtf._zfz': 'Processing Payment...',

  '_wdtg._wjl': 'No participation records yet',
  '_wdtg._tzje': 'Investment Amount',
  '_wdtg._zsy': 'Total Earnings',
  '_wdtg._hdts': 'Event Days',
  '_wdtg._cysj': 'Participation Time',
  '_wdtg._qzf': 'Go to Pay',
  '_wdtg._jxz': 'In Progress',
  '_wdtg._djszje': 'Total Pending Settlement',
  '_wdtg._gjb': '{a} items total',
  '_wdtg._djs': 'Pending Settlement',
  '_wdtg._zrsy': "Yesterday's Earnings",
  '_wdtg._dbl': 'Video-on-demand Views',
  '_wdtg._bfl': 'Play Count',
  '_wdtg._wdsy': 'My Earnings',
  '_wdtg._bqffc': 'Copyright Owner Share',
  '_wdtg._mr0djs': "Settle yesterday's earnings daily at 0:00",
  '_wdtg._jrsy': "Today's Earnings",
  '_wdtg._mygd': 'No more data',

  '_bqyy._bqyy': 'Copyright Cooperation Appointment',
  '_bqyy._qrbq': 'Confirm copyright cooperation appointment application?',
  '_bqyy._qx': 'Cancel',
  '_bqyy._tjyy': 'Submit Appointment',

  '_bqyy._spsq': 'Video Copyright Cooperation Application',
  '_bqyy._spsy': 'Promote videos together with copyright owners to bring more traffic and more earnings!',
  '_bqyy._ljyy': 'Book Now',
  '_bqyy._sphz': 'What is Video Copyright Cooperation Application?',
  '_bqyy._sphzsm': 'Video Copyright Cooperation Application provides more promotion opportunities for mutual benefit. Through application, you will gain recognition from copyright owners and have the chance for in-depth cooperation, obtaining more exposure and earnings.',
  '_bqyy._sqhch': 'Benefits of Copyright Cooperation',
  '_bqyy._llfz': 'Traffic Support',
  '_bqyy._llfzsm': 'Get platform promotion opportunities to increase exposure and play count.',
  '_bqyy._sytg': 'Increased Earnings',
  '_bqyy._sytgsm': 'Get higher advertising revenue share and business cooperation opportunities.',
  '_bqyy._yxhz': 'Priority Cooperation',
  '_bqyy._yxhzsm': 'Priority participation in platform official events and business cooperation projects.',
  '_bqyy._yytj': 'Appointment Conditions',
  '_bqyy._sptg': 'Video Ad Promotion Requirements',
  '_bqyy._sptgsm': 'Participate in at least 1 video promotion meeting platform standards.',
  '_bqyy._yysm': 'After clicking Book, our staff will contact you within 3 working days.',

  '_ybp._wdsy': 'My Earnings',
  '_ybp._dqye': 'Current Balance',
  '_ybp._jr': 'Today',
  '_ybp._jrzsy': "Today's Total Earnings",
  '_ybp._ljzsy': 'Total Cumulative Earnings',
  '_ybp._tgfh': 'Promotion Dividends',
  '_ybp._ljsy': 'Cumulative Earnings',
  '_ybp._bqsy': 'Copyright Earnings',
  '_ybp._yqfh': 'Referral Dividends',
  '_ybp._mrsy': 'Daily Earnings',
  '_ybp._tgsy': 'Promotion Earnings',

  '_tjdz._tjxd': 'Add New Address',
  '_tjdz._xzbz': 'Select Currency',
  '_tjdz._qbdz': 'Wallet Address',
  '_tjdz._srdz': 'Please enter wallet address',
  '_tjdz._qx': 'Cancel',
  '_tjdz._bc': 'Save',

  '_sz._smrz': 'Real-name Verification',
  '_sz._rzlx': 'Verification Type',
  '_sz._sfzzm': 'ID Card Front',
  '_sz._sfzfm': 'ID Card Back',
  '_sz._zsxm': 'Real Name',
  '_sz._qsrzsxm': 'Please enter real name',
  '_sz._sfzhm': 'ID Card Number',
  '_sz._qsrsfzhm': 'Please enter ID card number',
  '_sz._yyzz': 'Business License',
  '_sz._qymc': 'Company Name',
  '_sz._yyzzh': 'Business License Number',
  '_sz._qsrqymc': 'Please enter company name',
  '_sz._qsryyzzh': 'Please enter business license number',
  '_sz._qx': 'Cancel',
  '_sz._tjrz': 'Submit Verification',
  '_sz._zt': 'Status',
  '_sz._gr': 'Individual',
  '_sz._qy': 'Enterprise',
  '_sz._shz': 'Under Review',
  '_sz._ytg': 'Approved',
  '_sz._ybh': 'Rejected',

  '_mm._xgmm': 'Change Password',
  '_mm._dqxg': 'Change password regularly to protect account security',
  '_mm._dqmm': 'Current Password',
  '_mm._xmm': 'New Password',
  '_mm._qrxmm': 'Confirm New Password',
  '_mm._qx': 'Cancel',
  '_mm._qrxg': 'Confirm Change',

  '_jymm._xgjymm': 'Change Transaction Password',

  '_szzx._sz': 'Settings',
  '_szzx._yrz': 'Verified',
  '_szzx._wrz': 'Unverified',
  '_szzx._jymm': 'Transaction Password',
  '_szzx._szjymm': 'Set or change transaction password',
  '_szzx._tcdl': 'Log Out',
  '_szzx._qdtcdl': 'Are you sure you want to log out?',
  '_szzx._qrtc': 'Confirm Logout',
  '_szzx._qx': 'Cancel',

  '_yj._gy': 'About',

  '_yj._lxwm': 'Contact Us',

  '_yj._yszc': 'Privacy Policy',

  '_yj._yhxy': 'User Agreement',

  '_cd._gszz': 'Company Qualifications',

  '_cd._wmyy': 'We possess complete industry qualifications and certifications, providing users with legal, safe, and high-quality video services',

  '_cd._yyzz': "Valid proof of the company's legal operation, demonstrating our formal registration information and business scope",

  '_cd._yyzz2': 'A legally obtained company-certified business license, ensuring the legality and compliance of the platform',

  '_bz._lxkf': 'Click below to contact customer service, or contact us via customer service email or hotline',

  '_sz._bjtx': 'Edit',

  '_sz._bjxx': 'Edit Message',

  '_sz._tx': 'Avatar',

  '_sz._bcun': 'Save',

  '_db._zskf': 'Contact Support',
  '_db._zsry': 'Dedicated Agent',
  '_db._wdq': 'Unread',
  '_db._ydq': 'Read',

  '_sc._sctp': 'Upload Image',
  '_sc._xztp': 'Choose Image',
  '_sc._fstp': 'Send Image',
  '_sc._qx': 'Cancel',
  '_sc._hd': 'Okay',

  '_zcyl._zcbt': 'Sign-up Bonus',
  '_zcyl._djdkhb': 'Tap to Open Red Packet',
  '_zcyl._zclj': 'Registration Reward',
  '_zcyl._hmyzh': 'No Account Yet?',
  '_zcyl._qzc': 'Sign Up',
  '_zcyl._qxdjhb': 'Please Claim Your Red Packet First',
  '_zcyl._qwzc': 'Proceed to Sign Up',
  '_zcyl._hbysy': 'Red Packet Already Used',

  '_ggtg._qhz': 'Go to Transfer',
  '_ggtg._dqye': 'Current Balance',
  '_ggtg._qcz': 'Go to Deposit',
  '_ggtg._hzje': 'Transfer Amount',
  '_ggtg._ljhz': 'Transfer Now',
  '_ggtg._yebz': 'Insufficient Balance',

  '_sq._bhbt': 'Rejected',

  '_sq._bhyy': 'Reason for rejection',

  '_xx._ntq': '{n} days ago',

  '_xx._nxsq': '{n} hours ago',

  '_xx._nfzq': '{n} minutes ago',

  '_xx._nggq': 'Just now',

  '_xx._djckgd': 'Click to view more',

  '_ct._zt': 'Status',

  '_ct._ljz': 'Connecting',

  '_ct._ylj': 'Connected',

  '_ct._ltlieb': 'Chat List',

  '_ct._bnhzj': 'Cannot chat with myself',

  '_ct._cylb': 'Member List',

  '_hb._fhb': 'Red Envelope',

  '_hb._dqye': 'Current Balance',

  '_hb._fsd': 'Sent to',

  '_hb._hbje': 'Red Envelope Amount',

  '_hb._qshuru': 'Please enter red envelope amount',

  '_hb._ljfs': 'Send Now',

  '_hb._hbz': 'Red Envelope Blessing',
  '_hb._qshuruzhu': 'Please enter your blessing',

  '_sp._cuow': 'Episodes 1-10 need to be unlocked before you can watch',

  '_bq._tzzq': 'Investment Period',

  '_bq._zrsy': "Yesterday's Profit",

  '_bq._bqtz': 'Copyright Investment',

  '_bq._tzdj': 'Investment Amount',

  '_bq._zfjz': 'Payment must be made within 24 hours, otherwise it will be considered a waiver!',

  '_bq._qzf': 'Make Payment',

  '_bq.jz': 'Deadline',

  '_bq._ljzf': 'Pay Now',

  '_bq._sqbz': 'Application Notes (Optional)',

  '_bq._sqbzsm': 'Please Enter Application Notes',

  '_bq._zzsqz': 'Copyright application in progress, awaiting review...',

  '_app._xz': 'Download the ReelShortBiz application',

  '_app._smerm': 'Scan the QR code to download',

  '_app._xzbt': 'Download',

  '_m._yhzz': 'Bank Transfer',
  '_m._yhxx': 'Bank Information',
  '_m._yhmz': 'Bank Name',
  '_m._yhdz': 'Bank Address',
  '_m._yhmc': 'Name',
  '_m._yhzh': 'Account',
  '_m._yhlx': 'Type',
  '_m._yhly': 'Routing',
  '_m._yhdm': 'Code',
  '_m._yhbz': 'Note',
  '_m._fzxx': 'Copy Info',

  '_m._zts': 'Prompt',
  '_m._zyd1': "1. Please carefully verify the recipient's name, account number, and bank code when transferring. Any error may result in loss of remittance",
  '_m._zyd2': "2. It is recommended to select 'Sender bears all fees' to avoid insufficient receipt amount due to intermediary bank deductions",
  '_m._zyd3': '3. Transfers usually take 1-3 business days. Please wait patiently. If you have any questions, please contact customer service',
  '_m._zyd4': '4. If you have any other questions, please contact customer service',

  '_m._jyh': 'Transaction Number',
  '_m._jyje': 'Amount',

  '_sp._dbye': 'VOD Balance',
  '_sp.hzye': 'Transfer',
  '_sp._txje': 'Transfer Amount',
  '_sp._qsrtxje': 'Please enter transfer amount',
  '_sp._ljhz': 'Transfer Now',
  '_sp._yebz': 'Insufficient balance',
  '_sp._qshuru': 'Please enter correct transfer amount',
  '_sp._fanh': 'Back',

  '_sp._tliu': 'Ad Placement',
  '_sp._xzgj': 'Select Country',
  '_sp._cdcw': 'Video Encoding Error',
  '_ggtf._hot': 'Hot',
  '_tl._tlsj': 'Ad Time',
  '_tl._xzxb': 'Select Gender',
  '_tl._nan': 'Male',
  '_tl._nv': 'Female',
  '_tl._hunhe': 'Mixed',
  '_tl._xznl': 'Select Age',
  '_sp._us': 'United States',
  '_sp._en': 'United Kingdom',
  '_sp._jp': 'Japan',
  '_sp._fr': 'France',
  '_sp._kr': 'South Korea',
  '_sp._de': 'Germany',
  '_sp._id': 'India',
  '_sp._in': 'Indonesia',
  '_sp._au': 'Australia',
  '_sp._es': 'Spain',
  '_sp._my': 'Malaysia',
  '_sp._cn': 'China',
  '_ggtf._fanhui': 'Back',
  '_ggtf._jymmts': 'Please confirm the transaction amount and enter your password',
  '_wdtg._wjl_desc': "You haven't participated in any advertising campaigns yet",
  '_wd._jxz': 'In Progress',
  '_wd._djs': 'Pending Settlement',
  '_wd._ywc': 'Completed',
  '_wd._jz': 'Urgent',
  '_wd._hz': 'Transfer',

  '_tl._tlfbqk': 'Ad Spend Distribution',
  '_tl._tlfbqk_desc': 'Days 1-5: 5% (Cold Start Phase), Days 6-10: 20% (Content Validation Phase), Days 11-15: 40% (IP Building Phase), Days 16-20: 35% (Short Drama Matrix Phase)',

  '_nhz._sm': 'After transfer, the amount will be transferred to the video wallet for unlocking video content',
  '_nhz._zhzz': 'Transferring...',
  '_nhz._zzcg': 'Transfer successful',
  '_nhz._zhzsb': 'Transfer failed, please try again',
  '_m._fzcg': 'Copied successfully',
  '_m._fzsb': 'Copy failed, please copy manually',
  '_m._zwfzxx': 'No information to copy',
  '_tx._qb': 'All',
  'activity.detail': 'Activity Details',
  'activity.noDesc': 'No activity description',
  'activity.desc': 'Activity Description',
  'activity.requirements': 'Participation Requirements',
  'activity.minInvest': 'Minimum Investment',
  'activity.vipLevel': 'VIP Level',
  'activity.avgParticipation': 'Average Participation',
  'activity.avgParticipationDesc': 'times',
  'activity.country': 'Select Country',
  'activity.deliveryTime': 'Ad Delivery Time',
  'activity.deliveryTimeDesc': 'days',
  'activity.gender': 'Select Gender',
  'activity.male': 'Male',
  'activity.female': 'Female',
  'activity.mixed': 'Mixed',
  'activity.age': 'Select Age',
  'activity.amount': 'Purchase Amount',
  'activity.back': 'Back',
  'activity.join': 'Join Now',
  emptyData: 'No Data',
  emptyDataDesc: 'No participating ad campaigns',
  completedtlement: 'Expired',
  preheat: 'Preheating',
  progress: 'In Progress',
  settlement: 'Pending Settlement',
  transfered: 'Transferred',
  completed: 'Completed',
  activityCode: 'Activity Code',
  touzAmount: 'Investment Amount',
  activityDays: 'Activity Days',
  joinTime: 'Join Time',
  playSource: 'Play Source Distribution',
  allPlatforms: 'All Platforms',
  other: 'Other',
  totalPlayNum: 'Total Plays',
  incomeSummary: 'Income Summary',
  totalPay: 'Copyright Fees Paid',
  totalIncome: 'Total Income',
  copyrightRatio: 'Copyright Holder Share',
  promotionIncome: 'Promotion Income',
  copyrightIncome: 'Copyright Share',
  playNum: 'Plays',
  buyNum: 'On-demand Plays',
  incomeRate: 'Share Ratio',
  yjIncome: 'Estimated Income',
  paid: 'Paid',
  timeout: 'Timed Out',
  transfer: 'Transfer Now',
  loading: 'Loading...',
  loadMore: 'Load More',
  noMore: 'No More',
  nightTime: 'Night Period',
  morningTime: 'Morning Period',
  afternoonTime: 'Afternoon Period',
  eveningTime: 'Evening Period',
  '_h._tc': 'Logout',
  periodPayment: 'Period Payment',
  periodPaymentDesc: 'Settlement occurs 4 times daily in 4 periods, you can pay copyright fees per period',

  day: 'day',
  '_dl._hy': 'Welcome back',
  '_dl._cj': 'Create Account',
  '_dl._zmm': 'Reset Password',
  '_dl._hyDesc': 'Log in to your account to continue exploring great content',
  '_dl._cjDesc': 'Join ReelShortBiz and start your exciting journey',
  '_dl._zmmDesc': "Enter your email and we'll send a verification code to reset",
  '_dl._hlgqsp': 'Massive HD movie and video resources',
  '_dl._gxhty': 'Personalized recommendation algorithms',
  '_dl._ffddsp': 'Rich short videos',
  '_dl._dlzh': 'Log In',
  '_dl._sdndyx': 'Enter your email and password to continue',
  '_dl._email': 'Email Address',
  '_dl._qsryx': 'Please enter your email address',
  '_dl._dlmm': 'Password',
  '_dl._qsrmm': 'Please enter your password',
  '_dl._wjmm': 'Forgot password?',
  '_dl._immdl': 'Log In Now',
  '_dl._hmyzh2': "Don't have an account?",
  '_dl._ljzc2': 'Sign Up Now',
  '_dl._cjzh': 'Create Account',
  '_dl._jswmd': 'Join ReelShortBiz and start your exciting journey',
  '_zh._qszmm': 'Please set your password',
  '_zh._qrmm': 'Confirm Password',
  '_zh._qmm': 'Please enter password again',
  '_zc._yqm': 'Invitation Code',
  '_zc._sryqm': 'Please enter invitation code',
  '_dl._yzm': 'Verification Code',
  '_dl._qsryzm': 'Please enter verification code',
  '_dl._yjyzh': 'Already have an account?',
  '_dl._zcbsty2': 'By registering you agree to',
  '_dl._zcbstyDesc': 'Privacy Policy',
  '_dl._newmm': 'New Password',
  '_dl._qszxmm': 'Please set new password',
  '_dl._qrmm': 'Confirm Password',
  '_dl._qzcsrmm': 'Please enter new password again',
  '_dl._czmm': 'Reset Password',
  '_dl._xqlmm': 'Remembered your password?',
  '_dl._fhdl': 'Back to Login',
  '_dl._srdllmmbyz': 'Passwords do not match',
  '_dl._czcg': 'Password reset successfully',
  '_h._zc': 'Register',
  // '_ybp._wdsy': 'My Earnings',
  '_ybp._jrsy': "Today's Earnings",
  '_ybp._jztr': 'Compared to yesterday',
  '_ybp._bfl': 'Views',
  '_ybp._dbl': 'Requests',
  '_ybp._syqs': 'Earnings Trend',
  // '_ybp._jr': 'Today',
  '_ybp._t': 'day',
  // '_ybp._dqye': 'Account Balance',
  '_ybp._djs': 'Pending Settlement',
  '_ybp._zhl': 'Conversion Rate',
  '_ybp._sjgl': 'Data Overview',
  '_ybp._zrsy': "Yesterday's Earnings",
  '_ybp._bysy': "This Month's Earnings",
  '_ybp._yysj': 'Operational Data',
  '_ybp._zr': 'Yesterday',
  '_ybp._zjfrs': 'Total Paying Users',
  '_ybp._mtdqje': 'Amount Due Tomorrow',
  '_ybp._jsy': 'Net Earnings',
  '_ybp._bqfy': 'Copyright Fee Payment Plan',
  '_ybp._yzf': 'Paid',
  '_ybp._qzf': 'Go to Pay',
  '_ybp._bqfyts': 'After paying copyright fees, your earnings and rights will be prioritized',
  '_ybp._syjl': 'Earnings History',
  '_ybp._ckgd': 'View More',
  '_ybp._ssdt': 'Live Updates',
  '_ybp._bzzx': 'Help Center',
  '_ybp._lxkf': 'Contact Support',
  '_ybp._zrxz': "Yesterday's Earnings",
  '_ybp._zdsy': 'Total Earnings',
  '_ybp._qygy': 'Last Month',
  '_ybp._jsjl': 'Settlement History',
  '_ybp._hzjl': 'Transfer History',
  '_ybp._jfzq': 'minutes ago',
  '_ybp._djs_mt': "Tomorrow's Settlement Amount",
  '_yj._rule': 'Platform Rules',

  '_bq._jjks': 'Start Now',
  '_bq._jxz': 'In Progress',
  '_bq._jks': 'Time to Start',
  '_bq._jjs': 'Time to End',
  '_bq._t': 'd',
  '_bq._h': 'h',
  '_bq._m': 'm',
  '_bq._s': 's',
  '_bq._kssj': 'Start Time',
  '_bq._jssj': 'End Time',
  '_bqq._tzdj': 'Unit Price',
  '_bqq._hdts': 'Event Duration',
  '_bqq._vip': 'VIP Level',
  '_bqq._rjcy': 'Average Participation',
  '_bqq._cs': 'times',
  '_bqq._ysjd': 'Sold Progress',
  '_bqq._ljqg': 'Buy Now',
  '_bqq._zbkqg': 'Currently Unavailable',
  '_bqq._jzz': 'Loading',
  '_bqq._jzgd': 'Load More',
  '_bqq._wz': 'No More Items',

  '_sp._gdsj': 'Total {n} episodes',
  '_sy._jl': 'Pending Settlement Record',
  '_ybp._zsy': 'Total Revenue',
  '_ybp._djsjl': 'Pending Settlement Record',
  '_ybp._bqbm': 'Code',
  '_ybp._je': 'Amount',
  '_ybp._sj': 'Time',
  '_sy._djs': 'Pending',
  '_sy._yjs': 'Settled',
  '_sy._gdstjl': 'Total {n} records',
  '_sy._gjd': 'Total {n}'
}
